import type { PlpConfig } from '#types/config/pages/plp'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    breadcrumbs: 'my-4 text-sm md:my-6',
    categoryTitle: 'my-4 title-2',
    container: 'container',
    eSpotAboveGrid: 'my-4 md:(mb-8 mt-6)',
    eSpotAboveGridBelowHeading: 'mt-6 lg:mt-8',
    eSpotLazyAboveFooter: 'my-4 md:(mb-8 mt-6) [&_.container]:px-0',
    productCount: 'hidden'
  },
  defaultSort: 'bestMatches',
  showBreadcrumbsLastStep: true,
  sorts: {
    NORA: [
      'bestMatches',
      'whatsNew',
      'priceLowToHigh',
      'priceHighToLow'
    ],
    EMEA: [
      'bestMatches',
      'whatsNew',
      'priceLowToHigh',
      'priceHighToLow'
    ]
  },
  showAboveGridBelowHeadingEspot: true
} satisfies RecursivePartial<PlpConfig>
